import {
    type CaseTaskPending,
    useFetchCaseTasksPending,
} from "@/queries/useFetchCaseTasksPending.ts";
import { Badge, Tooltip } from "@mui/material";
import { CheckSquare } from "lucide-react";

type Props = {
    caseUUID: string;
};

const CaseTaskBadgeForCase = ({ caseUUID }: Props) => {
    const { data: caseTasksData = [], isLoading } = useFetchCaseTasksPending();

    if (!caseTasksData || isLoading) {
        return null;
    }

    const foundCaseTasks = caseTasksData.filter((caseTask: CaseTaskPending) => {
        return caseTask.case.idUUID === caseUUID;
    }).length;

    if (foundCaseTasks === 0) {
        return null;
    }

    const tooltipText = `${foundCaseTasks} case task${foundCaseTasks === 1 ? "" : "s"}`;

    return (
        <Tooltip title={tooltipText} arrow>
            <Badge
                badgeContent={foundCaseTasks}
                sx={{
                    pl: 1,
                    "& .MuiBadge-badge": {
                        backgroundColor: "green",
                        color: "white",
                    },
                }}
            >
                <CheckSquare size={20} color="green" />
            </Badge>
        </Tooltip>
    );
};

export default CaseTaskBadgeForCase;
